module.exports = __webpack_public_path__ + "img/2f_r_kasuya@2x.d7f24644.jpg";